import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StarIcon from "../ui/StarIcon";
import * as styled from "./StarBalance.styled";

// Баланс звёзд ученика в шапке. Для других ролей ничего не рендерит.
function StarBalance() {
  const { data } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  if (!data || data.userType !== "student") return null;

  const stars = data.stars ?? 0;

  return (
    <styled.Badge key={stars} title="Твої зірки — відкрити магазин" onClick={() => navigate("/student/shop")}>
      <StarIcon size={20} />
      <styled.Count>{stars}</styled.Count>
    </styled.Badge>
  );
}

export default StarBalance;
